module.exports = __webpack_public_path__ + "static/media/listIcon.4960c577.svg";